import { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";

import { DropdownButtonContainer } from "./styled";
import { ButtonsPopup, FlexContainers, SmallButton, SVG, WrapperContainer } from "../index";
import { alignItems, colors } from "../../consts";
import { autoUpdate, flip, hide, offset, useFloating } from "@floating-ui/react-dom";
import { createPortal } from "react-dom";

const DropdownButton = ({ title, children, secondary, optionsWidth }) => {
  const [visible, setVisible] = useState(false);

  const containerRef = useRef();
  const portal = document.getElementById("dropdown-portal");

  const toggleVisibility = (e) => {
    e.stopPropagation();
    setVisible((prev) => !prev);
  };

  const floatingProps = useFloating({
    open: visible,
    placement: "bottom",
    whileElementsMounted: autoUpdate,
    middleware: [flip({ padding: 4 }), offset(4), hide({ padding: 10 })],
    elements: { reference: containerRef.current }
  });

  useEffect(() => {
    if (floatingProps.middlewareData.hide?.referenceHidden) {
      setVisible(false);
    }
  }, [floatingProps.middlewareData.hide]);

  return (
    <DropdownButtonContainer ref={containerRef}>
      <SmallButton secondary={secondary} onClick={toggleVisibility}>
        <WrapperContainer
          Container={FlexContainers.FlexRowCenter}
          gap={5}
          alignItems={alignItems.center}>
          {title}
          <SVG.DownArrowIcon color={colors.RAISIN_100} />
        </WrapperContainer>
      </SmallButton>
      {visible &&
        createPortal(
          <div
            ref={floatingProps.refs.setFloating}
            style={{
              ...floatingProps.floatingStyles
            }}>
            <ButtonsPopup
              visible={visible}
              setVisible={setVisible}
              containerRef={containerRef}
              style={{ position: "unset", width: optionsWidth ? `${optionsWidth}px` : undefined }}>
              {children}
            </ButtonsPopup>
          </div>,
          portal
        )}
    </DropdownButtonContainer>
  );
};

DropdownButton.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  secondary: PropTypes.bool,
  optionsWidth: PropTypes.number
};

export default DropdownButton;
